import {RejectTranslate} from "./RejectTranslate";
import {ConfirmTranslate} from "./ConfirmTranslate";


export const ButtonFunctions = [ConfirmTranslate, RejectTranslate];

